export enum LiquidityTaskBarItem {
  SYSTEM_ACCOUNT_GROUPS = 'system-account-groups',
  CUSTOM_ACCOUNT_GROUPS = 'custom-account-groups',
  PARTY_EXPLORER = 'party-explorer',
  FAVORITES = 'favorites'
}
